import React from 'react'
import { ModuleNames } from '../../../../constants/componentNames.constants'
import { FooterColumn } from '../style'
import formatInlineCode from '../../../../utils/shortTextFormatting'

const buildColumn = (start: number, end: number, menuItems: any) => {
  let column = []

  for (let i = start; i < end; i++) {
    let heading = menuItems[i]?.newGroupName
    if (heading) column.push(<h6 key={`heading-${i}`}>{heading}</h6>)

    let index = 0
    let listItems = []
    const pages = menuItems[i]?.pages || []

    for (let link of pages) {
      let className =
        link?.__typename === ModuleNames.TOPIC_ICON_LINK ? { className: 'Footer__Text--Bold' } : {}

      listItems.push(
        <li key={`${link.groupStyle}-${index}`}>
          <a {...className} href={link?.url || link?.externalUrl}>
          {formatInlineCode(link?.text || link?.ctaText)}
          </a>
        </li>
      )
      index++
    }

    column.push(<ul key={`listItems-${i}`}>{listItems}</ul>)
  }

  return <div key={`start-${start}_end-${end}`}>{column}</div>
}

export const renderFooterLinks = (menuGroups: any) => {
  /*
   * Only considering for desktop (12 column layout), responsive will be handled in styles,
   * a menu list spans two columns width on desktop, hence two columns is 4.
   */
  const TWO_COLUMNS = 4
  const ONE_COLUMN = 2
  const COLUMN_END = 13

  let columnStart = 1,
    index = 1,
    finalMarkup = []

  for (let i = 0; i < menuGroups.length; i++) {
    const menuGroup = menuGroups[i]
    let pages = 'pages' in menuGroup ? menuGroup.pages : []
    let columns = ONE_COLUMN

    //* only split list into two columns if more than >= 4 menu groups
    if (pages.length >= 4) columns = TWO_COLUMNS

    let markup = []
    if (columns === TWO_COLUMNS) {
      let mid = Math.ceil(pages.length / 2)
      markup.push(buildColumn(0, mid, pages), buildColumn(mid, pages.length, pages))
    } else markup.push(buildColumn(0, pages.length, pages))

    columnStart = columnStart > COLUMN_END || columnStart + columns > COLUMN_END ? 1 : columnStart

    finalMarkup.push(
      <FooterColumn
        key={i}
        $columns={columns}
        $columnStart={columnStart}
        $columnEnd={columnStart + columns}
        $menuIndex={index}>
        <div className="Footer__Group-Title">
          <p>{'newGroupName' in menuGroup ? menuGroup.newGroupName : ''}</p>
          <span></span>
        </div>
        {markup}
      </FooterColumn>
    )

    columnStart += columns
    index++
  }

  return finalMarkup
}
